export const RENAME_CITIES_MAP = {
    1961: 'SOUTH_MALE_ATOLL',
    752:  'NORTH_MALE_ATOLL',
};
